import { getSupabase } from '@/lib/supabase';
import type { SessionId, SessionIndexEntry, UserId } from '@/schemas';
import { encodeSessionIndexToRow } from '../codec';

interface EnsureSessionIndexParams {
  sessionId: SessionId;
  userId: UserId;
  createdAt?: number;
  updatedAt?: number;
  deletedAt?: number;
}

export async function ensureSessionIndexEntry(params: EnsureSessionIndexParams): Promise<void> {
  const { sessionId, userId, createdAt, updatedAt, deletedAt } = params;
  const client = getSupabase();
  const now = Date.now();

  const entry: SessionIndexEntry = {
    sessionId,
    userId,
    createdAt: createdAt ?? now,
    updatedAt: updatedAt ?? now,
    deletedAt,
  };

  const { error } = await client
    .from('session_index')
    .upsert(encodeSessionIndexToRow(entry), { onConflict: 'session_id,user_id' });
  if (error) {
    throw error;
  }
}
